<!--<h2 mat-dialog-title>-->
<!--  🔍 Filtrer les produits-->
<!--  <span class="text-sm font-normal text-gray-500 block">Allergènes et ingrédients</span>-->
<!--</h2>-->
<h2 mat-dialog-title class="text-center  text-site md:text-start">
  🔍 Filtrer les produits
  <span class="text-sm font-normal text-gray-500 block">Allergènes et ingrédients</span>
</h2>
<div class="flex gap-4 px-4">
  <button
    mat-flat-button
    [matButton]="mode === 'flags' ? themeConfig.appearance.button.neutral : 'tonal'"
    (click)="switchMode('flags')"
    [class.!border]="mode !== 'flags'"
    [class.!border-base-300]="mode !== 'flags'"
    class="w-full whitespace-nowrap">
    Allergènes
  </button>
  <button
    mat-flat-button
    [matButton]="mode === 'ingredients' ? themeConfig.appearance.button.neutral : 'tonal'"
    (click)="switchMode('ingredients')"
    [class.!border]="mode !== 'ingredients'"
    [class.!border-base-300]="mode !== 'ingredients'"
    class="w-full whitespace-nowrap">
    Ingrédients
  </button>
</div>
<mat-dialog-content class="p-4">

  <!-- Liste -->
  @if (loading) {
    <div class="flex flex-col justify-center items-center py-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-secondary"></div>
      <span class="ml-2 text-gray-600 mt-2">Chargement en cours...</span>
    </div>
  }
  @if (!loading && items.length === 0) {
    <div class="text-center py-8 text-gray-500">
      Aucun élément trouvé
    </div>
  }

  <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
    @for (item of items; track item) {
      <div class=" bg-card  p-3 gap-1 lg:gap-2">
        <div class="flex items-center gap-3">
          <mat-checkbox
            [checked]="item.selected"
            (change)="onCheckboxChange(item, $event)">
            <span class=" text-site inline-block whitespace-normal break-words max-w-[90px] sm:max-w-[100px] leading-tight">
              {{ item.name }}
            </span>
          </mat-checkbox>
        </div>
        <mat-button-toggle-group
          [(value)]="item.sign"
          hideSingleSelectionIndicator="true"
          class="sign-toggle-group">
          <mat-button-toggle value="+" class="toggle-plus">Avec +</mat-button-toggle>
          <mat-button-toggle value="-" class="toggle-minus">Sans -</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
    }
  </div>
</mat-dialog-content>
<div class="flex justify-center items-center gap-2 px-4 pb-4">
  <button
    [matButton]="themeConfig.appearance.button.cancel"
    class="w-full"
    (click)="onCancel()">
    Annuler
  </button>
  <button
    [matButton]="themeConfig.appearance.button.action"
    class="w-full"
    (click)="onApply()">
    Valider
  </button>
</div>
